/* assets/clear-cart.js */
(function () {
  // ====== CONFIG ======
  const KNOWN_KEYS = ['Recipient Name', 'Label Products', 'Label Name'];
  const NET30_THANKYOU_PATH = '/pages/net-orders-thank-you';
  const WIPE_HOLD_MS = 1500; // 1.5s hold around checkout/visibility changes
  const HOLD_KEY = 'bb_cart_wipe_hold_until';
  const LAST_ATTR_SAVE_KEY = 'bb_cart_last_attr_save';
  // widened to cover more themes/app flows
  const ADD_ENDPOINTS = ['/cart/add', '/cart/add.js', '/cart/add.json'];

  // ====== HELPERS ======
  function path(p) {
    try { return new URL(p, location.origin).pathname.replace(/\/+$/, ''); }
    catch { return (p || '').split('?')[0].replace(/\/+$/, ''); }
  }
  const here = path(location.pathname);
  const isNet30ThankYou = (here === NET30_THANKYOU_PATH);

  async function fetchJSON(url, opts) {
    const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, (opts || {})));
    if (!res.ok) throw new Error(url + ' failed: ' + res.status);
    return res.json();
  }
  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  async function getCart() { return fetchJSON('/cart.js'); }

  async function clearLineItems() {
    try { await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', keepalive: true }); } catch {}
  }

  function updateCartCountUI(count) {
    try {
      const selectors = ['.header-cart-count', '.cart-count-bubble', '[data-cart-count]', '.thb-cart-form--count'];
      document.querySelectorAll(selectors.join(',')).forEach(el => {
        if (el.classList && el.classList.contains('thb-cart-form--count')) {
          el.textContent = count > 0 ? '(' + count + ')' : '';
        } else {
          el.textContent = String(count || 0);
          el.setAttribute('data-cart-count', String(count || 0));
          const bubble = el.closest && el.closest('.cart-count-bubble');
          if (bubble) bubble.hidden = !count;
        }
      });
    } catch {}
  }

  // ---- Harden theme refresh to avoid console crashes if something still fires it with missing nodes
  (function hardenThemeCartRefresh() {
    try {
      if (window.ThemeCart && typeof window.ThemeCart.refresh === 'function' && !window.ThemeCart.__bbWrapped) {
        const _refresh = window.ThemeCart.refresh;
        window.ThemeCart.refresh = function () {
          try { return _refresh.apply(this, arguments); }
          catch (e) {
            // Ignore null.classList errors that happen when DOM was intentionally cleared
            if (e && String(e.message || e).indexOf('classList') !== -1) return;
            throw e;
          }
        };
        window.ThemeCart.__bbWrapped = true;
      }
    } catch {}
  })();

  function visuallyClearCartUI() {
    try {
      updateCartCountUI(0);

      document
        .querySelectorAll('.cart-drawer .cart-item, .mini-cart .cart-item, .cart-items li, .thb-cart-drawer .cart-item')
        .forEach(n => n.remove());

      document
        .querySelectorAll('.cart-subtotal .amount, .cart-drawer__subtotal .amount, .mini-cart__subtotal-amount, [data-cart-subtotal]')
        .forEach(el => { el.textContent = '0'; });

      document
        .querySelectorAll('.cart-empty, .thb-cart-form--empty, [data-empty-cart]')
        .forEach(el => el.removeAttribute('hidden'));

      const drawer = document.querySelector('.cart-drawer, .mini-cart, .thb-cart-drawer');
      if (drawer) {
        drawer.setAttribute('data-cart-empty', 'true');
        const closeBtn = drawer.querySelector('[data-drawer-close], .drawer__close, [data-action="close"]');
        if (closeBtn) closeBtn.click();
        drawer.classList.remove('is-open', 'open', 'active');
      }

      // Only dispatch events if the exact container themes usually touch still exists.
      // Prevents ThemeCart.refresh() from running against missing nodes.
      const hasCartItemsContainer = document.querySelector('.cart__items');
      if (hasCartItemsContainer) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: 0 } }));
        document.dispatchEvent(new CustomEvent('thb:cart:update', { detail: { item_count: 0 } }));
      }
    } catch {}
  }

  function getHoldRemaining() {
    try {
      const until = Number(sessionStorage.getItem(HOLD_KEY) || 0);
      return until ? Math.max(0, until - Date.now()) : 0;
    } catch { return 0; }
  }

  function buildPayloads(attrsInCart) {
    const keys = new Set(KNOWN_KEYS);
    Object.keys(attrsInCart || {}).forEach(k => keys.add(k));
    const nulls = {}, empties = {};
    keys.forEach(k => { nulls[k] = null; empties[k] = ''; });
    return [
      { attributes: nulls, note: '' },
      { attributes: empties, note: '' },
    ];
  }

  async function postUpdate(payload) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-BB-Attr-Save': '1' // mark our wipe so main-cart hardening doesn't re-save
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      keepalive: true
    });
  }

  async function forceWipeAllMeta(maxRounds = 3) {
    for (let round = 0; round < maxRounds; round++) {
      let cart = await getCart();
      const payloads = buildPayloads(cart.attributes || {});
      for (const p of payloads) { try { await postUpdate(p); } catch {} }
      await sleep(200);
      cart = await getCart();
      const hasAttrs = cart.attributes && Object.keys(cart.attributes).some(k => (cart.attributes[k] || '') !== '');
      const hasNote = !!(cart.note && cart.note.trim().length);
      if (!hasAttrs && !hasNote) { return true; }
    }
    return false;
  }

  function isWipeHeld() {
    try {
      const until = Number(sessionStorage.getItem(HOLD_KEY) || 0);
      return !!(until && Date.now() < until);
    } catch { return false; }
  }

  function isAddURL(url) {
    try {
      const u = typeof url === 'string' ? url : (url && url.url) || '';
      return ADD_ENDPOINTS.some(p => String(u).indexOf(p) !== -1);
    } catch { return false; }
  }

  // Strengthen the HOLD on add-to-cart network calls (fetch)
  (function patchFetchForAdd() {
    if (!window.fetch) return;
    const _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      if (isAddURL(input)) {
        try { sessionStorage.setItem(HOLD_KEY, String(Date.now() + WIPE_HOLD_MS)); } catch {}
        // For slower themes, consider extending slightly:
        // try { sessionStorage.setItem(HOLD_KEY, String(Date.now() + 2200)); } catch {}
      }
      return _fetch(input, init);
    };
  })();

  // Also hold for add-to-cart via XHR
  (function patchXhrForAdd() {
    if (!window.XMLHttpRequest) return;
    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isAddURL(url)) {
        try { sessionStorage.setItem(HOLD_KEY, String(Date.now() + WIPE_HOLD_MS)); } catch {}
      }
      return _open.apply(this, arguments);
    };
  })();

  // Also hold for add-to-cart traditional form POSTs
  document.addEventListener('submit', function (e) {
    try {
      const f = e.target;
      if (!f || !f.action) return;
      const action = new URL(f.action, location.origin).pathname;
      if (ADD_ENDPOINTS.some(p => action.indexOf(p) !== -1)) {
        sessionStorage.setItem(HOLD_KEY, String(Date.now() + WIPE_HOLD_MS));
      }
    } catch {}
  }, true);

  function recentAttrSave(withinMs) {
    try {
      const t = Number(sessionStorage.getItem(LAST_ATTR_SAVE_KEY) || 0);
      if (!t) return false;
      return (Date.now() - t) < withinMs;
    } catch { return false; }
  }

  // sturdier, avoids false positives right after add-to-cart
  async function isReallyEmpty() {
    const a = await getCart();
    await sleep(400);
    const b = await getCart();
    if ((b.item_count || 0) > 0) return false; // an item just landed
    await sleep(400);
    const c = await getCart();
    return ((a.item_count || 0) === 0) && ((b.item_count || 0) === 0) && ((c.item_count || 0) === 0);
  }

  async function checkAndWipeIfEmpty() {
    try {
      if (isWipeHeld()) return;
      if (recentAttrSave(20000)) return; // keep this guard
      if (!(await isReallyEmpty())) return;

      // Now we’re confident it’s empty
      await forceWipeAllMeta();
      updateCartCountUI(0);

      // Optional: only visually clear on the full cart page (avoid drawer flicker)
      const onCartPage = /\/cart(?:\/|$|\?)/.test(location.pathname);
      if (onCartPage) visuallyClearCartUI();
    } catch {}
  }

  // ====== MAIN ======
  async function run() {
    if (isNet30ThankYou) {
      // Wait enough for Flow/app to read the cart.
      // min 1.5s, add small buffer to remaining hold, cap at 5s
      const floor = 1500;
      const remain = getHoldRemaining();
      const delay = Math.min(5000, Math.max(floor, remain + 500));
      await sleep(delay);
      await clearLineItems();
      await forceWipeAllMeta();
      updateCartCountUI(0);
      visuallyClearCartUI();
      return;
    }
    await checkAndWipeIfEmpty();
  }

  run();

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { run(); }
  });

  function scheduleCheck() { setTimeout(checkAndWipeIfEmpty, 350); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.quantity .plus') || e.target.closest('.quantity .minus')) scheduleCheck();
    if (e.target.closest('.cart-remove-mobile, .cart-remove-desktop')) scheduleCheck();
    const a = e.target.closest && e.target.closest('a[href*="quantity=0"]');
    if (a) scheduleCheck();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'updates[]') scheduleCheck();
  }, true);

  let tries = 4;
  const iv = setInterval(() => { checkAndWipeIfEmpty(); if (--tries <= 0) clearInterval(iv); }, 800);

  // Hold window around checkout/accelerated/Net30
  document.addEventListener('click', function (e) {
    const el = e.target.closest('button, a, input[type="submit"]');
    if (!el) return;
    const href = el.getAttribute('href') || '';
    const name = el.getAttribute('name') || '';
    const html = el.outerHTML || '';
    const isNormalCheckout = name === 'checkout' || /\/checkout(?:\?|$)/.test(href);
    const isAccelerated = el.closest('.additional-checkout-buttons') ||
                          el.classList.contains('shopify-payment-button') ||
                          /shop-pay|paypal|paynow|google|gpay|apple|amazon/i.test(html);
    const isNet30Link = /\/pages\/net-orders-thank-you(?:\?|$)/.test(href) ||
                        /termscheckout|payment\s*terms/i.test(html);
    if (isNormalCheckout || isAccelerated || isNet30Link) {
      try { sessionStorage.setItem(HOLD_KEY, String(Date.now() + WIPE_HOLD_MS)); } catch {}
    }
  }, true);

  // Strengthen the hold for accelerated/iframe cases (no click bubbles)
  window.addEventListener('pagehide', function () {
    try { sessionStorage.setItem(HOLD_KEY, String(Date.now() + WIPE_HOLD_MS)); } catch {}
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      try { sessionStorage.setItem(HOLD_KEY, String(Date.now() + WIPE_HOLD_MS)); } catch {}
    }
  });
})();